module.exports = __webpack_public_path__ + "img/hyundai-Worth.ae0026d0.png";